import { memo } from 'react';
export var hasItemPropsAreEqual = function hasItemPropsAreEqual(prev, next) {
  return prev.onChange === next.onChange && prev.disabled === next.disabled && prev.label === next.label && prev.value === next.value && prev.isSelected === next.isSelected;
};
export var memoItem = function memoItem(Component) {
  return memo(Component, hasItemPropsAreEqual);
};